import React, { useState } from "react";

import { InfiniteScroll, QuickFilter } from "../../components";

import { LookbookItem } from "../molecules";
import { isMobile } from "react-device-detect";

export function Lookbooks() {
  const [query, setQuery] = useState("");

  return (
    <div className="container">
      <div
        className={`d-flex justify-content-end flex-wrap justify-content-md-between ${
          isMobile ? "px-3 pt-1" : "p-3 pb-0 p-md-0 mt-4"
        }`}
      >
        <QuickFilter
          className="listings"
          placeholder="Search"
          onUpdate={setQuery}
        />
      </div>

      <div className={`lookbook-list ${isMobile ? "mt-3" : ""}`}>
        <InfiniteScroll
          fetchUrl="/api/lookbooks/list"
          fetchParams={{ query }}
          emptyMessage="No lookbooks found."
          onResultsLoaded={() => {}}
          fetchLimit={20}
        >
          {({ items, isLoading, hasMore }) => (
            <div className="row">
              {items.length > 0 &&
                items.map((lookbook) => (
                  <LookbookItem key={lookbook.id} lookbook={lookbook} />
                ))}

              {!isLoading && items.length === 0 && (
                <div className="no-results">
                  <p>No lookbooks found.</p>
                </div>
              )}
            </div>
          )}
        </InfiniteScroll>
      </div>
    </div>
  );
}
